import { render } from "./MaterialTips.vue?vue&type=template&id=0db903c4"
import script from "./MaterialTips.vue?vue&type=script&lang=js"
export * from "./MaterialTips.vue?vue&type=script&lang=js"

import "./MaterialTips.vue?vue&type=style&index=0&id=0db903c4&lang=scss"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__